import { ITestimonial } from "~/utils/interface";

import author1_img from "/img/authors/paulathibodeaux.png";
import author2_img from "/img/authors/mamabear11.png";
import author3_img from "/img/authors/charming34.png";
import author4_img from "/img/authors/LitLovingLucy52.png";

export const TESTIMONIALS: ITestimonial[] = [
  {
    image: author1_img,
    stars: 5,
    text: "“Amazing setup. Quality audio with some surprisingly excellent voices, not some robotic annoying let down”",
    author: "paulathibodeaux",
  },
  {
    image: author2_img,
    stars: 5,
    text: "“If you want to listen to romance novels and not go broke doing it, Tempt is the best app for it”",
    author: "mamabear11",
  },
  {
    image: author3_img,
    stars: 5,
    text: "“I love being able to discover new authors, try different genres, and enjoy endless romance—all in one place!”",
    author: "charming34",
  },
  {
    image: author4_img,
    stars: 5,
    text: "“Tempt has brought the joy of reading back into my life. I’m now listening to even more than I ever read!”",
    author: "LitLovingLucy52",
  },
];
